/*!
 * @license
 * Copyright © 2005-2024 Hyland Software, Inc. and its affiliates. All rights reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { BaseApi } from './base.api';
import { throwIfNotDefined } from '../../../assert';
export class TaskVariablesApi extends BaseApi {
    createTaskVariable(taskId, restVariables) {
        throwIfNotDefined(taskId, 'taskId');
        throwIfNotDefined(restVariables, 'restVariables');
        const pathParams = {
            taskId
        };
        return this.post({
            path: '/api/enterprise/tasks/{taskId}/variables',
            pathParams,
            bodyParam: restVariables
        });
    }
    deleteAllLocalTaskVariables(taskId) {
        throwIfNotDefined(taskId, 'taskId');
        const pathParams = {
            taskId
        };
        return this.delete({
            path: '/api/enterprise/tasks/{taskId}/variables',
            pathParams
        });
    }
    deleteVariable(taskId, variableName, opts) {
        throwIfNotDefined(taskId, 'taskId');
        throwIfNotDefined(variableName, 'variableName');
        const pathParams = {
            taskId,
            variableName
        };
        return this.delete({
            path: '/api/enterprise/tasks/{taskId}/variables/{variableName}',
            pathParams,
            queryParams: opts
        });
    }
    getVariable(taskId, variableName, opts) {
        throwIfNotDefined(taskId, 'taskId');
        throwIfNotDefined(variableName, 'variableName');
        const pathParams = {
            taskId,
            variableName
        };
        return this.get({
            path: '/api/enterprise/tasks/{taskId}/variables/{variableName}',
            pathParams,
            queryParams: opts
        });
    }
    getVariables(taskId, opts) {
        throwIfNotDefined(taskId, 'taskId');
        const pathParams = {
            taskId
        };
        return this.get({
            path: '/api/enterprise/tasks/{taskId}/variables',
            pathParams,
            queryParams: opts
        });
    }
    updateVariable(taskId, variableName, restVariable) {
        throwIfNotDefined(taskId, 'taskId');
        throwIfNotDefined(variableName, 'variableName');
        throwIfNotDefined(restVariable, 'restVariable');
        const pathParams = {
            taskId,
            variableName
        };
        return this.put({
            path: '/api/enterprise/tasks/{taskId}/variables/{variableName}',
            pathParams,
            bodyParam: restVariable
        });
    }
}
